export const clone = <T>(obj: T): T => {
  return structuredClone(obj);
};
